import { Fragment } from 'react';
import type { ReactNode } from 'react';

import type { HeadProps } from '../../adapters';
import type { PageContext, PageData } from '../../config';
import { useAccessibility, useTranslate } from '../../hooks';

type Props = HeadProps<PageData, PageContext> & {
  children?: ReactNode;
};

export function PageHead({ pageContext, children }: Props) {
  const translate = useTranslate();
  const accessibility = useAccessibility();
  const {
    locale,
    title: pageTitle = translate(accessibility?.data.notfoundTitle),
    description: pageDescription = translate(accessibility?.data.notfoundMessage)
  } = pageContext;

  const title = [pageTitle, accessibility?.flatData.brandName].join(` | `);

  return (
    <Fragment>
      <html key="html" lang={locale} />
      <title key="title">{title}</title>
      <meta key="robots" name="robots" content="index, follow" />
      <meta key="description" name="description" content={pageDescription} />
      <meta key="og:locale" name="og:locale" content={locale} />
      <meta key="og:type" name="og:type" content="website" />
      <meta key="og:title" name="og:title" content={title} />
      <meta
        key="og:description"
        name="og:description"
        content={pageDescription}
      />
      <meta key="twitter:title" name="twitter:title" content={title} />
      <meta
        key="twitter:description"
        name="twitter:description"
        content={pageDescription}
      />
      <meta
        key="format-detection"
        name="format-detection"
        content="telephone=no"
      />
      {children}
    </Fragment>
  );
}
